var _g, _path, _g2, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 999,
    viewBox: "0 0 1000 999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.215743440233382,-0.21552769679306039)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 343 343",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 999,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.0740000000000407,0.07400000000001228)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342.85155851775386 342.85155851775386",
    height: 342.85155851775386,
    width: 342.85155851775386,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342.85155851775386 342.85155851775386",
    height: 342.85155851775386,
    width: 342.85155851775386,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 171.426c0-94.676 76.75-171.426 171.426-171.426 94.676 0 171.426 76.75 171.426 171.426 0 94.676-76.75 171.426-171.426 171.426-94.676 0-171.426-76.75-171.426-171.426zM171.426 332.353c88.878 0 160.927-72.05 160.927-160.927 0-88.878-72.05-160.927-160.927-160.928-88.878 0-160.927 72.05-160.928 160.928 0 88.878 72.05 160.927 160.928 160.927z",
    "data-fill-palette-color": "tertiary",
    fill: "#ffffff",
    stroke: "transparent"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 164.56874808852186,
    ry: 164.56874808852186,
    cx: 171.42577925887693,
    cy: 171.42577925887693,
    fill: "#ffffff",
    stroke: "transparent",
    strokeWidth: 0,
    fillOpacity: 0,
    "data-fill-palette-color": "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,64.84655864529837,113.21816446106916)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.1584412271571 116.41522959561551",
    height: 116.41522959561551,
    width: 213.1584412271571,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 213.1584412271571,
    viewBox: "0.85 -36.5 79.10000000000001 43.2",
    height: 116.41522959561551,
    "data-palette-color": "#121212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 6.7L15.85 6.7Q11.3 6.7 8.38 5.68 5.45 4.65 3.78 2.95 2.1 1.25 1.48-0.95 0.85-3.15 0.85-5.5L0.85-5.5 0.85-12.1Q0.85-12.75 1.03-13.23 1.2-13.7 1.5-13.95L1.5-13.95 8-19.4Q8.25-19.6 8.65-19.73 9.05-19.85 9.6-19.85L9.6-19.85 16.85-19.85Q17.4-19.85 17.82-19.73 18.25-19.6 18.55-19.35L18.55-19.35 18.55-28.75Q18.55-29.4 18.73-29.85 18.9-30.3 19.25-30.6L19.25-30.6 25.7-36.05Q25.95-36.25 26.38-36.38 26.8-36.5 27.3-36.5L27.3-36.5 35.15-36.5Q36.35-36.5 36.9-35.95 37.45-35.4 37.45-34.2L37.45-34.2 37.45-9.45Q37.45-7.1 36.77-5.13 36.1-3.15 34.4-1.75L34.4-1.75 27.95 3.7Q26.25 5.1 23.35 5.9 20.45 6.7 15.85 6.7ZM36.95-9.45L36.95-9.45 36.95-34.2Q36.95-35.15 36.52-35.58 36.1-36 35.15-36L35.15-36 27.3-36Q26.35-36 25.93-35.58 25.5-35.15 25.5-34.2L25.5-34.2 25.5-11.45Q25.5-10.45 24.93-9.78 24.35-9.1 22.2-9.1L22.2-9.1Q19.9-9.1 19.28-9.78 18.65-10.45 18.65-11.45L18.65-11.45 18.65-17.55Q18.65-18.5 18.23-18.93 17.8-19.35 16.85-19.35L16.85-19.35 9.6-19.35Q8.65-19.35 8.22-18.93 7.8-18.5 7.8-17.55L7.8-17.55 7.8-9.45Q7.8-7.15 8.43-5.28 9.05-3.4 10.68-2.08 12.3-0.75 15.13 0 17.95 0.75 22.3 0.75L22.3 0.75Q26.7 0.75 29.55 0 32.4-0.75 34.02-2.08 35.65-3.4 36.3-5.28 36.95-7.15 36.95-9.45ZM30.95-10.65L30.95-31.5 31.45-31.5 31.45-10.65Q31.45-7.7 29.58-5.8 27.7-3.9 22.4-3.9L22.4-3.9Q19.6-3.9 17.78-4.4 15.95-4.9 14.9-5.78 13.85-6.65 13.43-7.9 13-9.15 13-10.65L13-10.65 13-14.6 13.5-14.6 13.5-10.65Q13.5-7.8 15.38-6.1 17.25-4.4 22.4-4.4L22.4-4.4Q27.35-4.4 29.15-6.13 30.95-7.85 30.95-10.65L30.95-10.65ZM54.55-17.7L54.55-4.5 54.05-4.5 54.05-31.5 54.55-31.5 54.55-18.2 65.4-18.2 71.15-31.5 71.7-31.5 65.95-18.2 68-18.2Q71.05-18.2 72.55-17.05 74.05-15.9 74.05-13.3L74.05-13.3 74.05-4.5 73.55-4.5 73.55-13.3Q73.55-15.7 72.15-16.7 70.75-17.7 68-17.7L68-17.7 54.55-17.7ZM50.4 0L58.15 0Q59.1 0 59.52-0.43 59.95-0.85 59.95-1.8L59.95-1.8 59.95-13.25 66.55-13.25Q67.35-13.25 67.75-12.8 68.15-12.35 68.15-11.55L68.15-11.55 68.15-1.8Q68.15-0.85 68.57-0.43 69 0 69.95 0L69.95 0 77.65 0Q78.6 0 79.02-0.43 79.45-0.85 79.45-1.8L79.45-1.8 79.45-15.9Q79.45-18.9 77.77-20.73 76.1-22.55 73.3-22.7L73.3-22.7 78.4-34.35Q78.75-35.15 78.45-35.58 78.15-36 77.3-36L77.3-36 69.6-36Q68.65-36 68.05-35.63 67.45-35.25 67.1-34.35L67.1-34.35 61.95-22.7 59.95-22.7 59.95-34.2Q59.95-35.15 59.52-35.58 59.1-36 58.15-36L58.15-36 50.4-36Q49.45-36 49.02-35.58 48.6-35.15 48.6-34.2L48.6-34.2 48.6-1.8Q48.6-0.85 49.02-0.43 49.45 0 50.4 0L50.4 0ZM59.75 0.05L59.75 0.05 53.25 5.45Q53.05 5.65 52.62 5.8 52.2 5.95 51.7 5.95L51.7 5.95 43.95 5.95Q42.75 5.95 42.2 5.4 41.65 4.85 41.65 3.65L41.65 3.65 41.65-28.75Q41.65-29.4 41.82-29.85 42-30.3 42.35-30.6L42.35-30.6 48.8-36.05Q49.05-36.25 49.47-36.38 49.9-36.5 50.4-36.5L50.4-36.5 58.15-36.5Q59.35-36.5 59.9-35.95 60.45-35.4 60.45-34.2L60.45-34.2 60.45-29.65Q60.6-29.85 60.75-30.08 60.9-30.3 61.1-30.45L61.1-30.45 67.55-35.9Q67.9-36.2 68.42-36.35 68.95-36.5 69.6-36.5L69.6-36.5 77.3-36.5Q78.55-36.5 78.95-35.88 79.35-35.25 78.85-34.15L78.85-34.15 74.05-23.15Q76.75-22.8 78.35-20.85 79.95-18.9 79.95-15.9L79.95-15.9 79.95-1.8Q79.95-1.15 79.77-0.7 79.6-0.25 79.25 0.05L79.25 0.05 72.75 5.45Q72.55 5.65 72.12 5.8 71.7 5.95 71.2 5.95L71.2 5.95 63.5 5.95Q62.3 5.95 61.75 5.4 61.2 4.85 61.2 3.65L61.2 3.65 61.2-6.1Q61.2-6.6 61-6.9 60.8-7.2 60.45-7.25L60.45-7.25 60.45-1.8Q60.45-1.15 60.27-0.7 60.1-0.25 59.75 0.05Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "wordmark-text-0",
    "data-fill-palette-color": "quaternary",
    id: "text-0"
  })))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342.85155851775386,
    height: 342.85155851775386,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bc9d6a2fb7b21ac740ef31b66412e30.svg";
export { ForwardRef as ReactComponent };